import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { PurchaseOrderRequest } from "../models/purchase-order.model";

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderReceivedService {

  private url = environment.api + "api/erp/purchase/orders/received";
  constructor(
      private http: HttpClient,
  ) { }

  createReceived(body: any) {
    return this.http.post(`${this.url}/create`, body);
  }

  createUnifiedEntryScale(body: any){
    return this.http.post(`${this.url}/create-unified`, body);
  }

  getReceivedOrderDetails(orderId: number) {
    return this.http.get(`${this.url}/by-purchase-order/${orderId}`);
  }
}
